var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 13.3334C15.5528 13.3334 16.8395 12.9108 17.9057 12.1874C18.3095 11.9134 18.9074 12.231 18.764 12.6975C17.6123 16.4436 14.1245 19.1667 10.0007 19.1667C4.93804 19.1667 0.833984 15.0627 0.833984 10.0001C0.833984 5.2415 4.45989 1.32981 9.09957 0.877123C9.62316 0.851653 9.83606 1.57168 9.46451 1.94147C8.25148 3.14878 7.50065 4.82007 7.50065 6.66673C7.50065 10.3486 10.4854 13.3334 14.1673 13.3334Z",
    fill: "#131416"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDark);
export default __webpack_public_path__ + "static/media/icon-dark.e57aa10700f6cb52abf84032f4fa82c8.svg";
export { ForwardRef as ReactComponent };